import { getExpensesFilterOptions } from '@/composables/expenses/useExpensesList';
import { getFeesFilterOptions } from '@/composables/fees/useFeesList';

const createSummarySection = () => ({
  subtotal: 0,
  transferred_taxes: 0,
  withheld_taxes: 0,
  total: 0,
});

export const createInitialSaleMetrics = () => ({
  income: 0,
  expenses: 0,
  commissions: 0,
  utility: 0,
  margin: 0,
  utility_subtotal: 0,
  margin_subtotal: 0,
  utilitySubtotal: 0,
  marginSubtotal: 0,
  summary: {
    income: createSummarySection(),
    expenses: createSummarySection(),
    commissions: createSummarySection(),
  },
  income_summary: createSummarySection(),
  expenses_summary: createSummarySection(),
  commissions_summary: createSummarySection(),
});

export const createInitialExpenseSummary = () => ({
  total: 0,
  paid: 0,
  pending: 0,
});

export const createInitialFeeSummary = () => ({
  total: 0,
  paid: 0,
  pending: 0,
});

export const createDefaultSaleExpensesFilters = () => ({
  search: '',
  date_start: '',
  date_end: '',
  provider: [],
  expense_class: [],
  category: [],
  tags: [],
  has_xml: [],
  currency: [],
});

export const createDefaultSaleFeesFilters = () => ({
  search: '',
  date_start: '',
  date_end: '',
  provider: [],
  collaborator: [],
  expense_class: [],
  category: [],
  customer: [],
  tags: [],
  has_xml: [],
  currency: [],
  area: [],
});

export const createSaleDetailState = () => ({
  loading: false,
  sale: null,
  saleMetrics: createInitialSaleMetrics(),
  isSaleEditModalOpen: false,
  saleEditSectionKey: 'general',
  saleEditSubmitting: false,
  isDeleteSaleConfirmModalOpen: false,
  deletingSaleFromDetail: null,
  isExpenseModalOpen: false,
  expenseModalMode: 'create',
  expenseModalInitialData: null,
  isExpenseSubmitting: false,
  isApproveExpenseModalOpen: false,
  isApprovingExpense: false,
  approveExpenseTarget: null,
  approveExpenseTargetState: true,
  isPayExpenseModalOpen: false,
  isPayExpenseSubmitting: false,
  payExpenseTarget: null,
  isDeleteExpenseModalOpen: false,
  isDeletingExpense: false,
  deleteExpenseTarget: null,
  isClearSaleExpensesConfirmModalOpen: false,
  isClearingSaleExpenses: false,
  isFeeModalOpen: false,
  feeModalMode: 'create',
  feeModalInitialData: null,
  isFeeSubmitting: false,
  isApproveFeeModalOpen: false,
  isApprovingFee: false,
  approveFeeTarget: null,
  approveFeeTargetState: true,
  isPayFeeModalOpen: false,
  isPayFeeSubmitting: false,
  payFeeTarget: null,
  isDeleteFeeModalOpen: false,
  isDeletingFee: false,
  deleteFeeTarget: null,
  isClearSaleFeesConfirmModalOpen: false,
  isClearingSaleFees: false,
  activeTab: 'summary',
  expenseLoading: false,
  expenseRows: [],
  expenseFilterOptions: getExpensesFilterOptions(),
  expenseFilters: createDefaultSaleExpensesFilters(),
  expenseSearchText: '',
  expenseSearchDebounceMs: 1000,
  expenseSearchDebounceTimer: null,
  expenseActiveStatusTab: 'all',
  expenseCurrentPage: 1,
  expensePageSize: 20,
  expenseListRequestToken: 0,
  expenseMetricsRequestToken: 0,
  expenseInFlightRequestKey: '',
  expenseFiltersLoaded: false,
  expenseSummary: createInitialExpenseSummary(),
  feeLoading: false,
  feeRows: [],
  feeFilterOptions: getFeesFilterOptions(),
  feeFilters: createDefaultSaleFeesFilters(),
  feeSearchText: '',
  feeSearchDebounceMs: 1000,
  feeSearchDebounceTimer: null,
  feeActiveStatusTab: 'all',
  feeCurrentPage: 1,
  feePageSize: 20,
  feeListRequestToken: 0,
  feeMetricsRequestToken: 0,
  feeInFlightRequestKey: '',
  feeFiltersLoaded: false,
  feeSummary: createInitialFeeSummary(),
  paymentPlanInitialCustomerId: 0,
  paymentPlanOpenModalRequestId: 0,
});
